// extracted by mini-css-extract-plugin
export default {"icon":"Num08_icon__aI3SP"};